var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Card',[_c('Table',{ref:"table",attrs:{"loading":_vm.loading,"border":"","columns":_vm.columns,"data":_vm.booking_products}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }